import { Component, OnInit, Output, EventEmitter, ViewChild, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DemoService } from '../../../shared/demo.service';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  //styleUrls: ['./mobile.component.scss']
  styleUrls: ['../vquad/vquad.component.scss']
})
export class MobileComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoading = false;

  selectedRow: string;
  baseUrl: string;
  title: string;
  staticScreen = true;
  url: string;
  currentPage: number;
  // MatPaginator Inputs
  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [1, 10, 25, 100];
  pageIndex = 0;

  pageEvent: PageEvent;  // MatPaginator Output
  private commonFilter: CommonFilter;
  dataSource = new MatTableDataSource<any>([]);//[];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Output() childTitleEvent = new EventEmitter();

  columnsToDisplay = ['PhoneStatus', 'PhoneID_Abs', 'DeviceName_Abs', 'PhoneNumber_Abs', 'DeviceModel_Abs', 'GPS_Lat_Abs', 'GPS_Long_Abs', 'NodeTimestamp_Abs',
    'TestStatusID_Abs', 'Battery_Level_Abs', 'RSSI_Abs', 'Mode_Abs', 'select'];

  AutoRefreshInfo: any;
  interval;
  private subscriptions: Subscription[] = [];

  constructor(private commonFilterService: CommonFilterService, private http: HttpClient, private demoService: DemoService, private dialog: MatDialog, private router: Router) {
    this.baseUrl = environment.urlAddress + '/api/';

    this.commonFilterService.setNonFiltersScreen(true);

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        this.LoadNSMobileData();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(res)
        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);

            this.LoadNSMobileData();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
  }
  ngAfterViewInit() {
    //setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {

    this.LoadNSMobileData();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  OnReloadRoute() {
    this.router.navigateByUrl('statistics/nsmobile');
  }

  @Input() StatusMobileID: number = 0;
  LoadNSMobileData(event?: PageEvent) {
    debugger;
    this.commonFilter = new CommonFilter();
    if (event != undefined) {

      this.currentPage = +event.pageIndex + +1;
      //this.url = this.baseUrl + 'NwStat_VQuad/GetVquads_New?perPage=' + event.pageSize + '&pageNumber=' + this.currentPage;
      this.url = this.baseUrl + 'NwStat_Mobile/GetAllNwStat_Mobiles';
      this.commonFilter.PerPage = event.pageSize.toString();
      this.commonFilter.PageNumber = this.currentPage.toString();

    } else {
      this.url = this.baseUrl + 'NwStat_Mobile/GetAllNwStat_Mobiles';
      this.commonFilter.PerPage = this.pageSize.toString();
      this.commonFilter.PageNumber = "1";
    }
    //console.log(this.StatusMobileID)
    if (this.StatusMobileID != 0) {
      this.url = this.baseUrl + 'NwStat_Mobile/GetAllNwStat_MobileByID';
      this.commonFilter.ResultOrFileType = this.StatusMobileID;
    }

    this.GetAllData(this.commonFilter).subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      this.length = rows.length;
      this.dataSource.data = rows;
      this.isLoading = false;
    },
      err => {
        this.isLoading = false;
      });

    return event;
  }

  parentEvent(title) {
    //debugger;

    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  GetAllData(commFilter: CommonFilter) {

    //this.url = this.baseUrl + 'NwStat_Mobile/GetAllNwStat_Mobiles';
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, commFilter, options);
  }

  ///////////////////// checkbox selection
  selection = new SelectionModel<any>(true, []);

  //** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data != null ? this.dataSource.data.length : 0;
    return numSelected === numRows;
  }

  //** Selects all rows if they are not all selected; otherwise clear selection. */
  delButton: boolean;
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));

    this.delbuttonSet(1);
  }
  delbuttonSet(type, row?) {
    if (type == 2)
      this.selection.toggle(row);

    if (this.selection.selected.length > 0)
      this.delButton = true;
    else
      this.delButton = false;
  }

  //** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  DeleteNSMobile() {
    this.selectedRow = '';
    this.dataSource.data.filter((value, key) => {
      if (this.selection.isSelected(value)) {
        //console.log(value.ID_Abs);
        this.selectedRow = this.selectedRow + value.ID_Abs + ',';
      }
    });

    if (this.selectedRow != '') {

      const dailogConfig = new MatDialogConfig();
      dailogConfig.disableClose = true;
      dailogConfig.autoFocus = true;
      // dailogConfig.restoreFocus = true;
      dailogConfig.width = "40%";
      dailogConfig.data = { title: "Confirm Action", message: "Are you sure, you want to delete selected records?" };

      this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.DeleteMobileData(this.selectedRow).subscribe((res: any) => {
            this.LoadNSMobileData();
          });
        }
      });

      //if (confirm("Are you sure, you want to delete selected records?")) {
      //  this.DeleteMobileData(this.selectedRow).subscribe((res: any) => {
      //    this.LoadNSMobileData();
      //  });
      //}
    }

  }

  DeleteMobileData(nsMobileID: string) {
    this.url = this.baseUrl + 'NwStat_Mobile/DeleteMobileByID?nsMobileIDs=' + nsMobileID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);
  }
  ///////////////////////////////////// end checkbox

}
